// extracted by css-extract-rspack-plugin
export default {"input":"UiInput_input_uwI0M","intelligent":"UiInput_intelligent_Yg4SG","error":"UiInput_error_oYAGu"};